import React from 'react'
import styles from './FormError.module.css'

export default function FormError({ children }) {
  return <div className={styles.error}>{children}</div>
}
